import { noop } from '../../utils/index';
import { FieldError } from '../field-error/field-error';
export const TextArea = ({
    name,
    label,
    value,
    placeholder,
    onChange = noop,
    errors,
    touched,
    onBlurChange
}: {
    name: string;
    label?: string;
    value: string;
    placeholder?: string;
    errors: any;
    onBlurChange?: any;
    touched: any;
    onChange: (item: { [key: string]: string | number }) => void;
}) => {
    const handleChange = (e: { target: { value: string } }) => {
        onChange({ [name]: e.target.value });
    };

    return (
        <div className="mb-[24px]">
            {label && (
                <label
                    htmlFor={`text-${name}`}
                    className="block text-sm font-normal leading-6 text-gray-700"
                >
                    {label}
                </label>
            )}
            <div className="mt-1">
                <textarea
                    rows={4}
                    name={name}
                    onBlur={onBlurChange}
                    id={`text-${name}`}
                    defaultValue={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    className="shadow-sm mb-7 focus:ring-transparent outline-0 block w-full border-gray-dark  text-gray-darker not-italic font-light text-sm leading-6"
                />

                <FieldError errors={errors} touched={{}} field={name} />
            </div>
        </div>
    );
};
